<script setup lang="ts">
/**
 * Wachtwoordveld met oog-toggle. Opvolger van BaseComponents/VPasswordInput, nu op
 * VTextInput. Alle props van VTextInput werken hier ook (label, name, error, …).
 */
import { IconEye, IconEyeOff } from '@tabler/icons-vue'
import { computed, ref } from 'vue'
import VTextInput from './VTextInput.vue'

defineOptions({ inheritAttrs: false })

const modelValue = defineModel<string | null>()

const props = withDefaults(
    defineProps<{
        inputClasses?: string
    }>(),
    {
        inputClasses: '',
    }
)

const showPassword = ref(false)
const inputRef = ref<InstanceType<typeof VTextInput> | null>(null)

// `sentry-mask`: Sentry Replay toont de inhoud van dit veld nooit, ook niet als tekst.
const combinedInputClasses = computed(() => `sentry-mask ${props.inputClasses}`.trim())

defineExpose({ focus: () => inputRef.value?.focus() })
</script>

<template>
    <VTextInput
        ref="inputRef"
        v-bind="$attrs"
        v-model="modelValue"
        :type="showPassword ? 'text' : 'password'"
        :input-classes="combinedInputClasses"
    >
        <template #suffix>
            <button
                type="button"
                tabindex="0"
                :aria-label="showPassword ? $t('global.hide_password') : $t('global.show_password')"
                class="focus:outline-none"
                @click="showPassword = !showPassword"
            >
                <component
                    :is="showPassword ? IconEyeOff : IconEye"
                    class="w-5 h-5 cursor-pointer"
                />
            </button>
        </template>
    </VTextInput>
</template>
